// let apiBaseUrl = 'https://api.scde.cn/api'
// https://jb-api.scjb.gov.cn
// let apiBaseUrl = 'https://jb-cms.fm-dev.thecover.cn/api'
let apiBaseUrl = 'https://jb-api.scjb.gov.cn/api'
    // let pcDomain = 'https://www.scde.cn'
let pcDomain = 'https://jb-web.scjb.gov.cn'
    // let pcEnDomain = 'https://www.scde.cn/en'
let pcEnDomain = 'https://jb-web.scjb.gov.cn/en'
    // let wapDomain = 'https://www.scde.cn/wap'
    // wapDomain = 'https://jb-wap.scjb.gov.cn/'
let wapDomain = 'https://jb-wap.scjb.gov.cn/'
    // let yzgUrl = 'https://www.scde.cn/yzg'
let yzgUrl = 'https://jb-web.scjb.gov.cn/yzg'
    // let ylyzgUrl = 'https://www.scde.cn/ylyzg'
let ylyzgUrl = 'https://jb-web.scjb.gov.cn/ylyzg'

if (location.host === 'www.scjb.gov.cn') {
    apiBaseUrl = 'https://jb-api.scjb.gov.cn/api'
    pcDomain = 'https://www.scjb.gov.cn'
    pcEnDomain = 'https://www.scjb.gov.cn/en'
    wapDomain = 'https://www.scjb.gov.cn/'
    yzgUrl = 'https://jb-web.scjb.gov.cn/yzg'
    ylyzgUrl = 'https://jb-web.scjb.gov.cn/ylyzg'
} else if (location.host === 'https://jb-api.scjb.gov.cn/wap/') {
    apiBaseUrl = 'https://jb-api.scjb.gov.cn/api'
    pcDomain = 'https://jb-web.scjb.gov.cn'
    pcEnDomain = 'https://jb-web.scjb.gov.cn/en'
    wapDomain = 'https://jb-wap.scjb.gov.cn/'
    yzgUrl = 'https://jb-web.scjb.gov.cn/yzg'
    ylyzgUrl = 'https://jb-web.scjb.gov.cn/ylyzg'
} else if (location.host === 'jb-web.fm-dev.thecover.cn') {
    apiBaseUrl = 'https://jb-cms.fm-dev.thecover.cn/api'
    pcDomain = 'https://jb-web.fm-dev.thecover.cn'
    pcEnDomain = 'https://jb-web.fm-dev.thecover.cn/en'
    wapDomain = 'https://jb-web.fm-dev.thecover.cn/wap/'
    yzgUrl = 'https://jb-web.fm-dev.thecover.cn/yzg'
    ylyzgUrl = 'https://jb-web.fm-dev.thecover.cn/ylyzg'
}else{
    apiBaseUrl = 'https://jb-cms.fm-dev.thecover.cn/api'
    pcDomain = 'https://www.scjb.gov.cn'
    pcEnDomain = 'https://www.scjb.gov.cn/en'
    wapDomain = 'https://jb-wap.scjb.gov.cn/'
    yzgUrl = 'https://jb-web.scjb.gov.cn/yzg'
    ylyzgUrl = 'https://jb-web.scjb.gov.cn/ylyzg'
}

export default {
    apiBaseUrl: apiBaseUrl, // 接口地址
    pcDomain: pcDomain, // pc域名
    pcEnDomain: pcEnDomain, // pc英文域名
    wapDomain: wapDomain, // pc英文域名
    tenantId: 'FA9DA2211F880F10', // 中文tenantId
    enTenantId: 'F3487F5B0FAAD5A1', // 英文tenantId
    trackApiUrl: 'https://yun.thecover.cn/fmio/web/receive', // 数据部埋点地址
    yzgUrl: yzgUrl, // 云展馆地址
    ylyzgUrl: ylyzgUrl, // 云路演展馆地址
    pcPage: { // pc路径
        forum: 'cloudForum', // 云论坛和论坛详情
        speakers: 'guests', // 大会嘉宾和嘉宾详情
        channel: 'news/center', // 咨询中心
        views: 'news/views', // 精彩回顾
        faq: 'news/question', // 常见问题
        news: 'NewsDetail', // 新闻详情
        live: 'live', // 直播详情
        video: 'video', // 视频详情
        atlas: 'atlas', // 图集
        login: 'login', // 登录
        privacy: 'protocol/1', // 隐私协议
        agreement: 'protocol/2', // 用户协议
        declare: 'protocol/3', // 大会声明
        rightProtection: 'protocol/4', // 只是产权
        personal: 'personal', // 个人中心
        register: 'register', // 注册
        // channel: 'channel', // 频道详情页
        detail: 'detail', // 文章详情页
        reportInstructions: 'reportInstructions', // 举报须知
        reportDetails: 'reportDetails', // 举报详情的地址
        otherReports: 'otherReports', // 其他类
        authentication: 'authentication' // 监督员

    },
    apis: {
        getWeChatConf: '/common/weixin/getConfig', // 获取微信配置
        getHomeInfo: '/wap/home/homeInfo', // WAP主页信息查询
        // getHomeInfo: '/home/homeInfo', // WEB主页信息查询
        getMenu: '/home/menu', // 导航信息查询
        getHomeShare: '/home/share', // 主页分享信息
        getScheduleList: '/schedule/list', // 日程列表查询
        getGuestList: '/guest/list', // 嘉宾列表查询
        getGuestDetail: '/guest/get', // 嘉宾信息查询
        getForumList: '/forum/list', // 论坛列表查询
        getForumDetail: '/forum/get', // 论坛详情查询
        getChannelList: '/channel/itemList', // 新闻资讯
        getNewsDetail: '/news/get', // 新闻详情查询
        getLiveDetail: '/live/get', // 直播详情查询
        getQuestionList: '/question/list', // 常见问题查询
        getSubjectList: '/subject/itemList', // 专题内容查询
        sendCode: '/user/sendCode', // 发送手机验证码
        phoneLogin: '/user/phoneLogin', // 手机验证码登录
        logout: '/user/logout', // 登出
        statement: '/home/statement', // 隐私协议查询
        getVisitorInfo: '/exhibition/user/visitorInfo', // 参展足迹查询
        mianyangGetConf: '/user/mianyang/getConf', // i绵阳配置查询
        thirdInfo: '/user/thirdInfo', // 第三方用户信息查询
        questionClick: '/question/click', // 点击问题
        commonBlock: '/common/block/listNotPage', // 通用列表查询
        listZoneList:'/zone/list', //首页列表 新加的接口
        getHomeContact: '/home/contact', // 主页信息联系我们
        userLogin: '/user/login', // 账号密码登录
        userRegister: '/user/register', // 用户注册
        userGet: '/user/get', // 用户信息查询
        userUpdate: '/user/update', // 用户修改
        dictionaryList: '/dictionary/list', // 字典配置查询 0-行业 2-民族
        areaList: '/area/list', // 省市区联动查询
        userIdentify: '/user/identify', // 用户认证
        reportQueryReportByCode: '/report/queryReportByCode', // 通过举报码查询举报
        reportQueryReport: '/report/queryReport', //
        retrievePwdVerify: '/user/retrievePwd/verify', // 密码找回-验证码
        retrievePwdReset: '/user/retrievePwd/reset', // 密码找回-重置密码
        inviteCheck: '/invite/check', // 邀请码校验
        reportAddReport: '/report/addReport', // 创建举报
        reportTypeQueryReportType: '/reportType/queryReportType', // 危害小类
        reportGetImgVerifyCode: '/report/getImgVerifyCode', // 图形验证码
        channellist: '/channel/list', // 频道列表查询
        homeInfoMenu: '/home/infoMenu', // 网信信息
        footer: '/home/footer', // 友情链接
        reportQueryReportReply: '/report/queryReportReply', // 用户查看举报回复
        reportTypeQueryReportTypeContent: '/reportType/queryReportTypeContent', //
        userResetUsername: '/user/resetUsername', // 修改账号
        userResetPwd: '/user/resetPwd', // 修改密码
        getLeadToken: '/common/cloudStorage/getLeadToken', // 上传
        getImageToken: '/common/cloudStorage/getImageToken', // 上传
        getIdentify: '/user/identify/get', // 认证审核结果
        areagetAreaNameById: '/area/getAreaNameById', // 根据地域id查地域名称
        getUnitKindList:'/user/getUnitKindList', //获取单位性质
        getOrgKindList:'/user/getOrgKindList', //获取组织列表

        enterpriseInfringement:'/report/enterpriseInfringement/options', //涉企侵权举报页面下拉框选项
    }
}
